import { render, staticRenderFns } from "./loding.vue?vue&type=template&id=07cd6bac&scoped=true&"
import script from "./loding.vue?vue&type=script&lang=js&"
export * from "./loding.vue?vue&type=script&lang=js&"
import style0 from "./loding.vue?vue&type=style&index=0&id=07cd6bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd6bac",
  null
  
)

export default component.exports